<template lang="pug">
  v-row(justify="center")
    v-col.py-0.mt-3(cols="10")
      v-tabs(v-model="tab" centered fixed-tabs background-color="darkred")
        v-tabs-slider(color="red")
        v-tab.white--text(href="#product")
          v-icon mdi-package-variant
          | &nbsp; Product Features
        v-tab.white--text(href="#clazz")
          v-icon mdi-ticket
          | &nbsp; Class Features
      v-tabs-items.bg(v-model="tab")
        v-tab-item(value="product")
          feature-product-tab
        v-tab-item(value="clazz")
          feature-clazz-tab
</template>

<script>
import FeatureProductTab from '@/components/FeatureProductTab'
import FeatureClazzTab from '@/components/FeatureClazzTab'

export default {
  name: 'Features',
  components: { FeatureProductTab, FeatureClazzTab },
  data: () => ({
    tab: null,
  }),
  mounted () {
    
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.bg{
  background-color: #303030
}
</style>